import { Capacitor } from "@capacitor/core";

/**
 * @deprecated import from storage_utils instead
 */
export async function setLocalStorageItem(key: string, item: string) {
  if (((window as any).NativeStorage as boolean) && Capacitor.isNativePlatform()) {
    await NativeStorageSetItem(key, item);
  }
  window.localStorage.setItem(key, item);
}

/**
 * @deprecated import from storage_utils instead
 */
export async function getLocalStorageItem(key: string): Promise<string | null> {
  let toReturn = window.localStorage.getItem(key);
  if (((window as any).NativeStorage as boolean) && Capacitor.isNativePlatform()) {
    try {
      toReturn = await NativeStorageGetItem(key);
    } catch {
      toReturn = window.localStorage.getItem(key);
    }
  }

  return toReturn;
}

/**
 * @deprecated import from storage_utils instead
 */
export async function removeLocalStorageItem(key: string) {
  if (((window as any).NativeStorage as boolean) && Capacitor.isNativePlatform()) {
    await NativeStorageRemoveItem(key);
  }
  window.localStorage.removeItem(key);
}

/**
 * @deprecated import from storage_utils instead
 */
async function NativeStorageGetItem(key: string): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    (window as any).NativeStorage.getItem(
      key,
      (item: string) => {
        resolve(item);
      },
      (err: any) => {
        reject(err);
      }
    );
  });
}

/**
 * @deprecated import from storage_utils instead
 */
async function NativeStorageSetItem(key: string, item: string): Promise<void> {
  return new Promise((resolve, reject) => {
    (window as any).NativeStorage.setItem(
      key,
      item,
      () => {
        resolve();
      },
      (err: any) => {
        reject(err);
      }
    );
  });
}

/**
 * @deprecated import from storage_utils instead
 */
async function NativeStorageRemoveItem(key: string): Promise<void> {
  return new Promise((resolve, reject) => {
    (window as any).NativeStorage.remove(
      key,
      () => {
        resolve();
      },
      (err: any) => {
        reject(err);
      }
    );
  });
}
